import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.post('/report/getReport', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReportByBrand(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.post('/report/getReportByBrand', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getKeywords() {
      return new Promise((resolve, reject) => {
        axios.get('/crawler/getKeywords')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
